import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initializeIcons } from '@fluentui/react';
import '../styles/globals.css';
import { logger } from '@/utils/logger';
import { config } from '@/config';
import { initTelemetry } from '@/services/telemetry';

// Start telemetry first so unhandled errors and logs from boot onward are captured.
initTelemetry();

// Build identity for support: the one always-on boot line.
logger.info(
  `CRG FileSpace ${config.build.version}${config.build.sha ? ` (${config.build.sha})` : ''}`,
);

// Initialize Fluent UI icons
initializeIcons();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

// Check if Office.js is available and we're in an Office context
if (typeof Office !== 'undefined' && Office.context) {
  // We're in Office - wait for it to be ready
  Office.onReady((info) => {
    logger.debug('Office.onReady:', info);
    renderApp();
  });
} else if (typeof Office !== 'undefined') {
  // Office.js is loaded but context isn't ready yet
  Office.onReady((info) => {
    logger.debug('Office.onReady (delayed):', info);
    renderApp();
  });

  // Also render immediately for development outside Office
  // This allows testing the UI without being in Outlook
  setTimeout(() => {
    if (!rootElement.hasChildNodes()) {
      logger.debug('Rendering without Office context (development mode)');
      renderApp();
    }
  }, 1000);
} else {
  // No Office.js at all - just render
  logger.debug('No Office.js detected, rendering directly');
  renderApp();
}
